import React from 'react'
import { Label } from '@/components/ui/label'
import Spinner from '@/components/ui/spinner'
import { useBankData } from '@/features/client/hooks/use-bank-data'

interface BancoSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  error?: string
}

export const BancoSelect = React.forwardRef<HTMLSelectElement, BancoSelectProps>(
  ({ value, onChange, error, ...rest }, ref) => {
    const { data: bancos, isLoading, isError } = useBankData()
    const showFallbackInput = !isLoading && (isError || !bancos || bancos.length === 0)

    // Separar as props compatíveis manualmente para o input
    const inputProps: React.InputHTMLAttributes<HTMLInputElement> = {
      placeholder: 'Digite o nome ou código do banco',
      value: value as string,
      onChange: onChange as unknown as React.ChangeEventHandler<HTMLInputElement>,
      disabled: rest.disabled,
      name: rest.name,
      required: rest.required,
      className: 'border p-2 rounded w-full bg-input text-foreground'
    }

    return (
      <div className="space-y-2">
        <p>
          <strong>Informações de pagamento</strong>
        </p>
        <Label htmlFor="banco-select">
          Banco
          {isLoading && <Spinner className="ml-2" />}
        </Label>

        {showFallbackInput ? (
          <input type="text" id="banco-select" {...inputProps} />
        ) : (
          <select
            id="banco-select"
            ref={ref}
            value={value}
            onChange={onChange}
            className="border p-2 rounded w-full bg-input text-foreground"
            disabled={isLoading}
            {...rest}
          >
            <option value="">Selecione um banco</option>
            {bancos?.map(banco => (
              <option key={banco.ispb} value={banco.code}>
                {banco.code} - {banco.name}
              </option>
            ))}
          </select>
        )}

        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
      </div>
    )
  }
)

BancoSelect.displayName = 'BancoSelect'
